import { CommandController } from "./../../../commanding/CommandController";
import { WorldAssignment, Country } from "@goodgamestudios/world-assignment";
import { BasicClientCommand } from "./BasicClientCommand";
import { BasicController } from "../BasicController";
import { BasicModel } from "../../model/BasicModel";
import { CORE_LOGGER } from "../../../../../index";
import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("Connection.BasicChangeCountryCommand");

export class BasicChangeCountryCommand extends BasicClientCommand {
    public execute(newCountry: Country): void {
        if (!newCountry) {
            logger.warn("cant change country if no country is passed!");
            return;
        }
        const worldAssignment = (window.ggs.worldAssignment as WorldAssignment);
        const instanceProxy = BasicModel.instanceProxy;
        const currentCountry: Country = worldAssignment.facade.currentCountry;

        logger.debug(`currentInstance:  ${instanceProxy.selectedInstanceVO.instanceId} currentCountry.ggsCountryCode ${currentCountry.ggsCountryCode}  --> newCountry.ggsCountryCode ${newCountry.ggsCountryCode}`);

        if (currentCountry.ggsCountryCode === newCountry.ggsCountryCode) {
            logger.warn("same country was selected.  ignoring command");
            return;
        }

        this.env.customCDN = newCountry.cdn;
        BasicModel.networkCookie.country = newCountry.ggsCountryCode;
        if (this.env.accountCookie != null) {
            this.env.accountCookie.cdn = this.env.activeCDN;
        }

        const newServerInstance = worldAssignment.selectInstanceByCountry(newCountry);
        logger.info(`based on country ${newCountry.ggsCountryCode} WorldAssignment found instance ${newServerInstance.instanceId} --> ${newServerInstance.ip}`, newServerInstance);
        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECT_TO_INSTANCEVO, newServerInstance);
        CommandController.instance.executeCommand(BasicController.COMMAND_CHANGE_LANGUAGE, newCountry.ggsCountryCode);
    }
}
